/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { StaticQuery, graphql } from "gatsby"

import "./layout.css"

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <div>
          <main>{children}</main>
          <footer>
          <nav>
            {/* <Link to="/">Home</Link> */}
            {/* <Link to="/about/">About</Link> */}
            {/* <a href="https://www.notion.so/esiew/About-a23e5fb7812b41dd951b3a5bc1f7fda6" title="Go to Eugene's About page">About</a>*/}
            <a href="https://www.notion.so/esiew/Projects-2bbb2397fdf442cdbd85ddaa60a134a5" title ="Go to Eugene's Projects page">Projects</a>
            <a href="https://www.linkedin.com/in/eugenesiew" title="View Eugene's LinkedIn Profile" target="blank">LinkedIn</a>
            <a href="mailto:eugene@eugenesiew.com?subject=Greetings from " title="Email">Email</a>
          </nav><br/>
            © {new Date().getFullYear()}, Built with
            {` `}
            <a href="https://www.gatsbyjs.org">Gatsby</a> | Confidential<br/><br/>
            I study people and solve their design problems;<br/>I strive for simplicity and craftsmanship
          </footer>
        </div>
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
